import { Component, ChangeDetectionStrategy, Type } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { BaseFormlyFieldProps } from '../form-field/public_api';
import { SVGIcon, saveIcon } from "@progress/kendo-svg-icons";
interface TextButtonProps extends BaseFormlyFieldProps {
    buttonClick?: (field: any, event: any) => void;
    showButton?: (field: any, model: any) => boolean;
    svgIcon?: SVGIcon;
    buttonTitle?: string;
}

export interface FormlyTextButtonFieldConfig extends FormlyFieldConfig<TextButtonProps> {
    type: 'kendo-text-button' | Type<FormlyFieldTextButton>;
}

@Component({
    selector: 'formly-field-kendo-text-button',
    template: `
    <kendo-textbox [formControl]="formControl" [formlyAttributes]="field">
        <ng-template kendoTextBoxSuffixTemplate *ngIf="showButton">
            <button kendoButton
                [svgIcon]="props.svgIcon || defaultIcon"
                [title]="props.buttonTitle"
                [disabled]="this.props.disabled || this.props.readonly"
                (click)="props.buttonClick && props.buttonClick(field, $event)">
            </button>
        </ng-template>
    </kendo-textbox>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFieldTextButton extends FieldType<FieldTypeConfig<TextButtonProps>> {
    defaultIcon: SVGIcon = saveIcon;

    get showButton(): boolean {
        if (this.props.showButton) {
            return this.props.showButton(this.field, this.model);
        }
        return true;
    }
}
